module.exports = __webpack_public_path__ + "img/user_head.4fa5ad49.png";